import { useDisclosure } from '@chakra-ui/react';
import { createContext, useCallback, useContext, useState } from 'react';

const AppContext = createContext();

export function AppProvider({ children }) {
    /**
     * Pop up modal product bundle
     */
    const {
        isOpen: isOpenModalAddProductBundle,
        onOpen: onOpenModalAddProductBundle,
        onClose: onCloseModalAddProductBundle,
    } = useDisclosure();

    const modalAddProductBundle = {
        isOpenModalAddProductBundle,
        onOpenModalAddProductBundle,
        onCloseModalAddProductBundle,
    };

    /**
     * Pop up modal confirm upload product bundle
     */
    const {
        isOpen: isOpenModalConfirmAddProductBundle,
        onOpen: onOpenModalConfirmAddProductBundle,
        onClose: onCloseModalConfirmAddProductBundle,
    } = useDisclosure();

    const modalConfirmAddProductBundle = {
        isOpenModalConfirmAddProductBundle,
        onOpenModalConfirmAddProductBundle,
        onCloseModalConfirmAddProductBundle,
    };
    /**
     * Pop up modal product piece
     */
    const {
        isOpen: isOpenModalAddProductPiece,
        onOpen: onOpenModalAddProductPiece,
        onClose: onCloseModalAddProductPiece,
    } = useDisclosure();

    const modalAddProductPiece = {
        isOpenModalAddProductPiece,
        onOpenModalAddProductPiece,
        onCloseModalAddProductPiece,
    };

    /**
     * Pop up modal confirm upload product piece
     */
    const {
        isOpen: isOpenModalConfirmAddProductPiece,
        onOpen: onOpenModalConfirmAddProductPiece,
        onClose: onCloseModalConfirmAddProductPiece,
    } = useDisclosure();

    const modalConfirmAddProductPiece = {
        isOpenModalConfirmAddProductPiece,
        onOpenModalConfirmAddProductPiece,
        onCloseModalConfirmAddProductPiece,
    };

    /**
     * Toggle row product bundle
     */

    const [expanded, setExpanded] = useState(null);

    const toggleRow = (id) => {
        setExpanded(expanded === id ? null : id);
    };

    const expandedRow = {
        expanded,
        toggleRow,
    };

    /**
     * Context for validate form when adding product bundle
     */

    const [form, setForm] = useState({
        id: '',
        name: '',
        code: '',
        items: [],
    });

    const [errors, setErrors] = useState({
        name: '',
        code: '',
        items: '',
    });

    const validate = useCallback(() => {
        const newErrors = {};

        if (!form.name?.trim()) {
            newErrors.name = 'Nama wajib diisi.';
        }

        if (!form.code?.trim()) {
            newErrors.code = 'Kode wajib diisi.';
        }

        if (!Array.isArray(form.items) || form.items.length < 2) {
            newErrors.items = 'Minimal harus ada 2 item.';
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    }, [form]);

    const updateForm = (key, value) => {
        setForm((prev) => ({ ...prev, [key]: value }));
    };

    const addBundleValidation = {
        form,
        errors,
        validate,
        updateForm,
        setForm,
    };

    const value = {
        ...modalAddProductBundle,
        ...modalConfirmAddProductBundle,
        ...modalAddProductPiece,
        ...modalConfirmAddProductPiece,
        ...expandedRow,
        ...addBundleValidation,
    };

    return <AppContext.Provider value={{ ...value }}>{children}</AppContext.Provider>;
}

export function useApp() {
    return useContext(AppContext);
}
